import { CreateAppointmentPayload } from './inspection-appointment-create.request';

export type MobileBffCreateInspectionAppointmentRequest = Omit<CreateAppointmentPayload, 'customerId'>;
